// ./src/pages/privates/Contract/New/StepProduct/index.tsx
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import {
  IoChevronBack,
  IoChevronForward,
  IoCubeOutline,
} from 'react-icons/io5';

import {
  ButtonDefault,
  ButtonMain,
  CardSimpleIndicatorSelectable,
  InputText,
  Paragraph,
  SubtitleSecondary,
} from '@components/index';
import { ConfigStorage, ConfigStyles, ConfigValues } from '@config/index';
import Product from '@models/Product';
import { Pagination } from '@pages/private/User/Customer/List/styles';
import { newContractStorageService, apiRebox } from '@services/index';
import { formatText } from '@utils/formatters';
import { toastify } from '@utils/notifiers';

import {
  PaginationGroup,
  FormPage,
  PaginationGroupText,
} from '../../List/styles';
import { Container, Group, Buttons } from './styles';

interface IProps {
  myStep: number;
  currentStep: number;
  changeStep(newStep: number, willChangeHistory?: boolean): void;
}

const StepProduct: React.FC<IProps> = ({ currentStep, changeStep }) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedProductId, setSelectedProductId] = useState<any>(
    newContractStorageService.getProduct()?.id,
  );

  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const formPageSecondaryRef = useRef<FormHandles>(null);

  const getProducts = useCallback(async () => {
    try {
      const { data: response } = await apiRebox.get(`/products`, {
        params: {
          type: ConfigValues.rebox.product.type.plan,
          status: ConfigValues.rebox.product.status.active,
          page,
        },
      });
      setProducts(response.data);
      const { header } = response;
      setTotalPages(Math.ceil(header.total / header.per_page));
    } catch (error) {
      toastify(`Houve um erro ao buscar lista de opções de produtos.`, 'error');
    }
  }, [page]);

  const handleSaveProduct = useCallback((product: Product) => {
    newContractStorageService.updateProduct({
      id: product.id,
      field_type: 'PRODUCT_ID',
      query: product.id,
    });
    localStorage.setItem(
      'is_tracker_plan',
      JSON.stringify(product.name.includes('tracker')),
    );
    newContractStorageService.updateCart(product);
    setSelectedProductId(product.id);
  }, []);

  useEffect(() => {
    getProducts();
  }, [page]);

  return (
    <Container>
      <SubtitleSecondary textAlign="start" nameColor="black">
        Produto
      </SubtitleSecondary>
      <Paragraph
        textAlign="start"
        nameColor="black"
        opacity={0.8}
        fontWeight={500}
      >
        Escolha um de nossos produtos para prosseguir
      </Paragraph>
      <Group>
        {products.map(item => (
          <CardSimpleIndicatorSelectable
            key={item.id}
            icon={{
              element: IoCubeOutline,
              size: 20,
              opacity: 1,
              colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
              colorActive: ConfigStyles.rebox.colors.white.main,
            }}
            label={{
              text: formatText.capitalizedFirstLetter(item.name),
              colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
              colorActive: ConfigStyles.rebox.colors.white.main,
            }}
            onClick={() => handleSaveProduct(item)}
            isSelected={selectedProductId === item?.id}
            positionContent="center"
          />
        ))}
      </Group>
      <Pagination>
        <ButtonDefault
          style={{
            borderRadius: '8px 0 0 8px',
            maxWidth: 100,
          }}
          disabled={page === 1}
          isDisable={page === 1}
          onClick={() => setPage(1)}
        >
          Primeira
        </ButtonDefault>
        <ButtonDefault
          iconLeft={IoChevronBack}
          style={{
            borderRadius: '0',
            maxWidth: 30,
            padding: '0 5px',
            margin: '0 5px',
          }}
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        />
        <PaginationGroup>
          <FormPage
            ref={formPageSecondaryRef}
            onSubmit={() => []}
            initialData={{ currentPage: page }}
          >
            <InputText
              name="currentPage"
              type="number"
              min="1"
              onChange={event => {
                if (!(event.target.value === '')) {
                  setPage(Number.parseInt(event.target.value, 10));
                }
              }}
            />
          </FormPage>
          <PaginationGroupText>de {totalPages}</PaginationGroupText>
        </PaginationGroup>

        <ButtonDefault
          iconLeft={IoChevronForward}
          style={{
            borderRadius: '0',
            maxWidth: 30,
            padding: '0 5px',
            margin: '0 5px',
          }}
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        />
        <ButtonDefault
          style={{
            borderRadius: '0 8px 8px 0',
            maxWidth: 100,
          }}
          disabled={page === totalPages}
          isDisable={page === totalPages}
          onClick={() => setPage(totalPages)}
        >
          Última
        </ButtonDefault>
      </Pagination>
      <Buttons>
        <ButtonMain
          onClick={() => changeStep(currentStep + 1)}
          style={{ marginRight: '10px', maxWidth: 200 }}
          disabled={!selectedProductId}
          isDisable={!selectedProductId}
        >
          Avançar
        </ButtonMain>
        <ButtonDefault
          onClick={() => changeStep(currentStep - 1)}
          style={{ maxWidth: 200 }}
          disabled={currentStep <= 1}
          isDisable={currentStep <= 1}
        >
          Voltar
        </ButtonDefault>
      </Buttons>
    </Container>
  );
};

export default StepProduct;
